/**
 * sidebar.js - Sidebar container.
 *
 * This implements the sidebar menu displayed in all standard views.
 *
 * @author Alex Symeonidis
 */
import React, {Component} from "react";

import { Link, useHistory } from "react-router-dom";
import { connect } from "react-redux";

function LinkGroup(props) {
  let collapsed =
    (typeof props.collapsed !== 'undefined' && props.collapsed) || typeof props.collapsed === 'undefined';

  let localProps = {
    "data-target": '#collapse' + props.id,
    "aria-expanded": false,
    "aria-controls": 'collapse' + props.id
  }

  return <li className="nav-item">
    <a id={props.id} className={"nav-link" + (collapsed ? ' collapsed' : '')} {...localProps} data-toggle="collapse" aria-expanded="false">
      <i className={"fas " + props.icon}/>
      <span>{props.title}</span>
    </a>
    <div id={'collapse' + props.id} className={"collapse" + (collapsed ? '' : ' show')} aria-labelledby="headingTwo" data-parent="#accordionSidebar">
      <div className="bg-white py-2 collapse-inner rounded">
        {props.children}
      </div>
    </div>
  </li>
}

function LinkSubGroupTitle(props) {
  return <h6 className="collapse-header">{props.children}</h6>
}

function LinkItem(props) {
  let history = useHistory();

  function handleClick(event) {
    event.preventDefault();
    history.push(props.toUrl);
  }

  return <li className="nav-item">
    <Link className="nav-link" to={props.toUrl} onClick={handleClick}>
      <i className="fas fa-fw fa-tachometer-alt"/>
      <span>{props.title}</span></Link>
  </li>
}

function LinkButton(props) {
  let history = useHistory();

  function handleClick(event) {
    event.preventDefault();
    history.push(props.toUrl);
  }

  return (
    <Link id={props.id} className={'collapse-item'} to={props.toUrl} onClick={handleClick}>{props.children}</Link>
  )
}

class Sidebar extends Component {

  hasAdminRights = () => {
    return this.props.profile.roles.find(role => role.startsWith('ADMIN_')) !== undefined
  }

  hasRights = (rightsName) => {
    return this.props.profile.roles.find(role => role === rightsName) !== undefined
  }

  render() {
    return (
      <ul className="navbar-nav bg-gradient-primary sidebar sidebar-dark accordion" id="accordionSidebar">

        {/* Sidebar - Brand */}
        <Link className="sidebar-brand d-flex align-items-center justify-content-center" to="me">
          <div className="sidebar-brand-icon rotate-n-15">
            <i className="fas fa-laugh-wink"/>
          </div>
          <div className="sidebar-brand-text mx-3">R.E.A.L. Science</div>
        </Link>

        {/* Divider */}
        <hr className="sidebar-divider my-0"/>

        <LinkItem icon={'fas fa-fw fa-tachometer-alt'} title={'Ταμπλό Ελέγχου'} toUrl={'/me'}/>

        {
          this.hasAdminRights() &&
          <>
            {/* Divider */}
            <hr className="sidebar-divider"/>

            {/* Heading */}
            <div className="sidebar-heading">ΔΙΑΧΕΙΡΙΣΗ</div>

            {
              this.hasRights('ADMIN_VOLUNTEERS') &&
              <>
                <LinkGroup id={'sidebar-menu-volunteers'} title={'Εθελοντές'} icon={'fa-street-view'}>
                  <LinkSubGroupTitle>ΔΙΑΧΕΙΡΙΣΗ ΕΘΕΛΟΝΤΩΝ</LinkSubGroupTitle>
                  <LinkButton id={'sidebar-menu-volunteers-pending'}
                              toUrl={'/volunteer-applications'}>Αιτήσεις</LinkButton>
                </LinkGroup>
              </>
            }
          </>
        }
      </ul>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  profile: state.profile
});

export default connect(mapStateToProps)(Sidebar);